import { NavLink, useLocation } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { DASHBOARD_ICONS } from 'shared/assets/icons';
import { isActivePath } from 'navigation/TopNavigation';

export const DASHBOARD_NAV = [
  { to: paths.home, key: 'nav.home', icon: 'home', end: true },
  { to: paths.assessmentIntro, key: 'nav.assessment', icon: 'assessment', match: '/assessment' },
  { to: paths.history, key: 'nav.results', icon: 'results', match: '/results' },
  { to: paths.consultations, key: 'nav.consultations', icon: 'consultations', match: '/consultations' },
  { to: paths.notifications, key: 'nav.notifications', icon: 'notifications', match: '/notifications' },
  { to: paths.support, key: 'nav.support', icon: 'support', match: '/support' },
  { to: paths.companyPortal, key: 'nav.company', icon: 'profile', match: '/company' },
  { to: paths.profile, key: 'nav.profile', icon: 'profile', match: '/profile' },
];

export function DashboardNavLinks({ className, ariaLabel, unread = 0, onNavigate }) {
  const { t } = useI18n();
  const location = useLocation();
  return (
    <nav className={className} aria-label={ariaLabel || t('layout.dashboardNavigation')}>
      {DASHBOARD_NAV.map((item) => {
        const current = isActivePath(location.pathname, item);
        const Icon = DASHBOARD_ICONS[item.icon];
        return (
          <NavLink
            key={item.to}
            to={item.to}
            aria-current={current ? 'page' : undefined}
            className={current ? 'active' : undefined}
            onClick={onNavigate}
          >
            {Icon ? <Icon /> : null}
            <span>{t(item.key)}</span>
            {item.to === paths.notifications && unread > 0 ? (
              <span className="nav-badge" aria-label={t('home.unread', { count: unread })}>{unread}</span>
            ) : null}
          </NavLink>
        );
      })}
    </nav>
  );
}
